export default {
	install(Vue, config = {}) {

		/**
		 * 请求动作
		 */
		Vue.prototype.$action = Vue.ext.action = config.actions(
			Object.assign(function (url, options = {}, lock) {
				return function (body) {
					let { origin, pathname, search } = Vue.ext.url(url);
					options = Object.assign({
						request: (r, n) => n(r),
						response: (r, n) => n(r),
						body,
						method: 'GET',
						url: (origin || config.origin) + pathname,
						query: Object.defineProperty(Vue.ext.url.toObject(search), 'toString', {
							value() { return Vue.ext.url.toQuery(this); }
						})
					}, options);
					return new Promise((resolve, reject) => {
						options.request(body, data => {
							config.request(Object.assign(options, {
								body: data
							}), res => {
								config.response(res, r => {
									options.response(r, x => resolve(x));
								})
							});
						}, e => reject(e));
					})
				};
			}, {
					get(u, o = {}, l) {
						return this(u, Object.assign(o, { method: 'GET' }), l);
					},
					post(u, o = {}, l) {
						return this(u, Object.assign(o, { method: 'POST' }), l);
					},
					put(u, o = {}, l) {
						return this(u, Object.assign(o, { method: 'PUT' }), l);
					},
					delete(u, o = {}, l) {
						return this(u, Object.assign(o, { method: 'DELETE' }), l);
					},
				}
			),
			Object.assign({ $ext: Vue.ext }, config.plugins)
		);

	}
}


// WEBPACK FOOTER //
// ./src/vue-ext/script/action.js